var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3247 3.43994H2.66499C1.92909 3.43994 1.33252 4.03651 1.33252 4.77241V12.7672C1.33252 13.5031 1.92909 14.0997 2.66499 14.0997H13.3247C14.0606 14.0997 14.6572 13.5031 14.6572 12.7672V4.77241C14.6572 4.03651 14.0606 3.43994 13.3247 3.43994Z",
    stroke: "#1E1E1E",
    strokeOpacity: 0.4,
    strokeWidth: 1.3325,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6572 5.43848L8.68107 9.23601C8.47539 9.36487 8.23757 9.43322 7.99485 9.43322C7.75213 9.43322 7.51432 9.36487 7.30863 9.23601L1.33252 5.43848",
    stroke: "#1E1E1E",
    strokeOpacity: 0.4,
    strokeWidth: 1.3325,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlue);
export default __webpack_public_path__ + "static/media/blue.c610d9e47f1d33f74401f72406325b53.svg";
export { ForwardRef as ReactComponent };